module.exports = "<div class=\"dialog notes-dialog\">\n\n  <button mat-icon-button class=\"close-button\"\n    tabindex=\"-1\"\n    (click)=\"close()\">\n    <mat-icon>close</mat-icon>\n  </button>\n\n  <mat-dialog-content>\n    <app-rich-text-field #textField\n      [field]=\"field\"\n      [draftData]=\"draftData\"\n      [locked]=\"locked\"\n      [versionChanged]=\"versionChanged\"\n      (tabKey)=\"close()\"\n      (valueChanged)=\"onValueChange($event)\">\n    </app-rich-text-field>\n  </mat-dialog-content>\n\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/forms/notes-dialog.component.html
// module id = ./src/app/forms/notes-dialog.component.html
// module chunks = main